<template>
	<div class="content-wrapper">
		<div class="container flex-grow-1 container-p-y">

			<div class="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center mb-6 row-gap-4">
				<div class="d-flex flex-column justify-content-center">
					<h4 class="mb-1">{{ $t('agencies.list.title') }}</h4>
					<p class="mb-0">{{ $t('agencies.list.description') }}</p>
				</div>
				<div class="d-flex align-content-center flex-wrap gap-4">
					<router-link to="/agencies/create">
						<button type="submit" class="btn btn-primary">{{ $t('agencies.list.createButton') }}</button>
					</router-link>
				</div>
			</div>

			<div class="col-lg-12">
				<div class="card">
					<div class="card h-100">
						<div class="table-responsive">
							<table class="table table-borderless">
								<thead>
									<tr class="border-bottom">
										<th class="bg-transparent fs-xsmall">#</th>
										<th class="bg-transparent fs-xsmall">{{ $t('agencies.list.name') }}</th>
										<th class="bg-transparent fs-xsmall">{{ $t('agencies.list.address') }}</th>
										<th class="bg-transparent fs-xsmall">{{ $t('agencies.list.siren') }}</th>
										<th class="bg-transparent fs-xsmall">{{ $t('agencies.list.vatNumber') }}</th>
										<th class="bg-transparent fs-xsmall">{{ $t('agencies.list.invoiceReference') }}</th>
										<th class="bg-transparent fs-xsmall">{{ $t('agencies.list.employeesCount') }}</th>
										<th class="bg-transparent fs-xsmall">{{ $t('common.fields.actions') }}</th>
									</tr>
								</thead>
								<tbody class="table-border-bottom-0">
									<tr v-for="agency in agencies" :key="agency._id">
										<td>
											<div class="avatar avatar">
												<span class="avatar-initial rounded bg-label-primary">
													<i class="ri-building-line"></i>
												</span>
											</div>
										</td>
										<td>
											<span class="fw-medium">{{ agency.name }}</span>
										</td>
										<td>
											<span class="fw-medium text-truncate" v-if="agency.address">{{ agency.address }}</span>
											<span class="text-muted" v-else>—</span>
										</td>
										<td>
											<span class="fw-medium" v-if="agency.siren">{{ agency.siren }}</span>
											<span class="text-muted" v-else>—</span>
										</td>
										<td>
											<span class="fw-medium" v-if="agency.vatNumber">{{ agency.vatNumber }}</span>
											<span class="text-muted" v-else>—</span>
										</td>
										<td>
											<span class="fw-medium" v-if="agency.invoiceReference">{{ agency.invoiceReference }}</span>
											<span class="text-muted" v-else>—</span>
										</td>
										<td>
											<span class="badge rounded-pill bg-label-primary me-1" v-if="agency.employeesCount > 0">
												{{ agency.employeesCount }}
											</span>
											<span class="badge rounded-pill bg-label-secondary me-1" v-else>
												0
											</span>
										</td>
										<td>
											<a href="javascript:void(0);" class="btn btn-sm btn-icon btn-text-secondary rounded-pill me-1 waves-effect waves-light" @click="goToEdit(agency._id)">
												<i class="ri-pencil-line ri-22px"></i>
											</a>
											<a href="javascript:void(0);" class="btn btn-sm btn-icon btn-text-secondary rounded-pill me-1 waves-effect waves-light" @click="removeAgency(agency)">
												<i class="ri-delete-bin-6-line ri-22px"></i>
											</a>
										</td>
									</tr>
									<tr v-if="!agencies.length && !loading">
										<td colspan="8" class="text-center text-muted py-4">{{ $t('agencies.list.empty') }}</td>
									</tr>
								</tbody>
							</table>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import HTTP from "@/axios";

export default {
	name: "AgenciesList",

	data() {
		return {
			agencies: [],
			loading: false
		};
	},

	methods: {
		async fetchAgencies() {
			this.loading = true;
			try {
				const response = await HTTP.get("/agencies");
				this.agencies = response.data.agencies;
			} catch (error) {
				const errorMessage = error?.response?.data?.message || this.$t('errors.generic');
				alert(errorMessage);
				console.error("Erreur API:", error);
			} finally {
				this.loading = false;
			}
		},

		goToEdit(id) {
			this.$router.push(`/agencies/edit/${id}`);
		},

		async removeAgency(agency) {
			if (!confirm(this.$t('agencies.list.confirmDelete', { name: agency.name })))
				return;

			try {
				await HTTP.delete(`/agencies/${agency._id}`);
				await this.fetchAgencies();
			} catch (error) {
				const errorMessage = error?.response?.data?.message || this.$t('errors.generic');
				alert(errorMessage);
				console.error("Erreur API:", error);
			}
		}
	},

	async mounted() {
		await this.fetchAgencies();
	}
};
</script>

<style scoped>
.text-truncate {
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	max-width: 250px;
	display: inline-block;
}
</style>
